<template>
  <div class="grid">
    <div class="flex col-12 justify-content-center" v-if="loading"
         style="position: absolute;top: 50%;transform: translate(0, -50%);">
      <ProgressSpinner></ProgressSpinner>
    </div>
    <div class="col-12" v-show="!loading">
      <Card>
        <template #title>{{isResend ? 'Востановление хронологии' : 'Перевыгрузка'}} КИ по займам</template>
        <template #content>
          <div class="field mb-3">
            <label>Выберите бюро</label>
            <div class="flex flex-wrap gap-3">
              <div v-for="bureau in bureausOptions" :key="bureau.value" class="flex align-items-center">
                <Checkbox v-model="selectedBureaus" :inputId="bureau.value" :value="bureau.value" />
                <label :for="bureau.value" class="ml-2">{{ bureau.label }}</label>
              </div>
            </div>
          </div>
          <div class="field mb-3">
            <label for="fromDate" class="block mb-2">Дата, с которой начинается {{isResend ? 'востановление хронологии' : 'перевыгрузка'}}</label>
            <Calendar
              id="fromDate"
              v-model="fromDate"
              dateFormat="dd.mm.yy"
              :showIcon="true"
              placeholder="Выберите дату"
              style="max-width: 300px"
            />
          </div>
          <AbstractForm
              ref="form"
              :loading="formLoading"
              :on-commit=createResendLoans
              v-model="listForm"
              :commit-label="isResend ? 'Востановить хронологию КИ' : 'Перевыгрузить КИ'"
              commit-icon="pi pi-pencil"
          ></AbstractForm>
          <small class="p-text-secondary">Перевыгрузку лимита по ЦБ УИД необходимо осуществлять через старый функционал (не отмечен чек-бокс "Перевыгрузка по ID лимита")</small>
          <div class="flex flex-wrap gap-3 mb-3">
            <Checkbox v-model="isResend" inputId="resend" :binary="true" class="flex align-items-center"/>
            <label>Востановление хронологии (Без удаления)</label>
          </div>
          <div v-if="isResend" class="flex flex-wrap gap-3">
            <Checkbox v-model="isOnlyRejected" inputId="resend" :binary="true" class="flex align-items-center"/>
            <label>Востановить только недостающие (Убедись что у каждого займа есть хотя бы одно недостоющее событие)</label>
          </div>
          <div class="flex flex-wrap gap-3">
            <Checkbox v-model="isLimitId" inputId="limitId" :binary="true" class="flex align-items-center"/>
            <label>Перевыгрузка по ID лимита</label>
          </div>
          <small class="p-text-secondary">Отметить при необходимости перевыгрузить через ID лимита</small>
          <div v-if="isResend" class="field mt-3" style="max-width: 520px">
            <label for="eventTypes" class="block mb-2">Восстановить только выбранные события</label>
            <MultiSelect
              id="eventTypes"
              v-model="selectedEventGroups"
              :options="eventTypeOptions"
              optionValue="id"
              optionLabel="label"
              placeholder="Все события"
              display="chip"
              :filter="true"
              class="w-full"
            />
            <small class="p-text-secondary">Если ничего не выбрано, восстанавливаются все типы событий</small>
          </div>
          <div v-if="isIssueEventSelected" class="field mt-3" style="max-width: 520px">
            <label for="issueEventDate" class="block mb-2">Дата события 2.2</label>
            <Calendar
              id="issueEventDate"
              v-model="issueEventDate"
              dateFormat="dd.mm.yy"
              :showIcon="true"
              placeholder="Выберите дату"
              style="max-width: 300px"
            />
            <small class="p-text-secondary">2.2 будет восстановление только за эту дату</small>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import AbstractForm from "@/components/AbstractForm.vue";
import FormModel from "@/model/FormModel";
import LoanService from "@/service/LoanService";
import ResponseService from "@/service/ResponseService";
import { checkSendStops } from "@/helpers/sendStops";
import Checkbox from 'primevue/checkbox';
import Calendar from 'primevue/calendar';
import MultiSelect from 'primevue/multiselect';

const ISSUE_EVENT_ID = '2.2';

export default {
  name: "ResendLoansForm",
  components: {AbstractForm, Checkbox, Calendar, MultiSelect},
  props: {
    onCommit: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      formLoading: false,
      listForm: {
        loanIds: new FormModel('Список займов', { placeholder: 'Введите номер займа или ЦБ УИД или УИД заявки(для событий отказа по ПДЛ)' })
      },
      selectedBureaus: [],
      bureausOptions: [
        { label: 'НБКИ', value: 'nbki' },
        { label: 'Эквифакс', value: 'equ' },
      ],
      isResend: false,
      isLimitId: false,
      fromDate: null,
      isOnlyRejected: false,
      selectedEventGroups: [],
      issueEventDate: null,
      eventTypeOptions: [
        { id: '1.1', label: '1.1 - Заявка/отклоненная заявка', codes: ['ask', 'declined_ask', 'declined_ask_fin_core'] },
        { id: '1.2', label: '1.2 - Приоритетное одобрение', codes: ['prior_approve'] },
        { id: '1.3', label: '1.3 - Отказ', codes: ['declined', 'declined_fin_core'] },
        { id: '1.4', label: '1.4 - Одобрение', codes: ['approve'] },
        { id: '2.1', label: '2.1 - Изменения займа (все)', codes: ['change', 'change_tariff'] },
        { id: '2.2', label: '2.2 - Выдача', codes: ['issue'] },
        { id: '2.3', label: '2.3 - Платежи, обновления', codes: ['accrual', 'payment'] },
        { id: '2.5', label: '2.5 - Закрытие', codes: ['close'] },
        { id: '2.11', label: '2.11 - Закрытие по цессии', codes: ['close_cession'] },
      ],
    }
  },
  computed: {
    eventTypes() {
      const codes = this.selectedEventGroups.flatMap((id) => {
        const option = this.eventTypeOptions.find((el) => el.id === id);
        return option ? option.codes : [];
      });
      return [...new Set(codes)];
    },
    isIssueEventSelected() {
      return this.selectedEventGroups.includes(ISSUE_EVENT_ID);
    }
  },
  watch: {
    isLimitId(val) {
      this.listForm.loanIds.placeholder = val
          ? 'Введите список ID лимитов'
          : 'Введите номер займа или ЦБ УИД(в т.ч. ЦБ УИД лимита)';
    },
    isResend(val) {
      if (!val) {
        this.selectedEventGroups = [];
      }
    },
    isIssueEventSelected(val) {
      if (!val) {
        this.issueEventDate = null;
      }
    }
  },
  methods: {
    isCbUuid(value) {
      if (typeof value !== 'string') return false;
      const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-[0-9a-f]$/i;
      return uuidPattern.test(value);
    },

    isApplicationUuid(value) {
      if (typeof value !== 'string') return false;
      const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return uuidPattern.test(value);
    },
    createResendLoans() {
      if (this.selectedBureaus.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Не выбрано ни одно бюро',
          detail: 'Выберите хотя бы одно бюро для перевыгрузки.',
          life: 3000
        });
        return;
      }

      let value = this.listForm.loanIds.value;
      value = value.split(/[,\s]+/).filter(el => el.trim() !== '').map((el) => {
        const trimmed = el.trim();
        return /^\d+$/.test(trimmed) ? parseInt(trimmed, 10) : trimmed;
      })

      const hasStringValues = value.some(el => typeof el === 'string');

      const hasMixedTypes = value.some(el => typeof el === 'number') && hasStringValues;
      if (hasMixedTypes) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Некорректный ввод',
          detail: 'Нельзя смешивать числовые и строковые идентификаторы в одном запросе',
          life: 5000
        });
        return;
      }

      if (this.isLimitId && hasStringValues) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Некорректный ввод',
          detail: 'Для перевыгрузки по ID лимита используйте числовые идентификаторы',
          life: 5000
        });
        return;
      }

      let subjectType = 'loanId';

      if (this.isLimitId) {
        subjectType = 'limit';
      } else if (hasStringValues) {
        const firstStringValue = value.find(el => typeof el === 'string');

        if (this.isCbUuid(firstStringValue)) {
          subjectType = 'cbUuid';

          this.$confirm.require({
            message: 'Переотправка по ЦБ УИД для займов до 24 октября 2025 может работать некорректно. Продолжить?',
            header: 'Предупреждение',
            acceptLabel: 'Продолжить',
            acceptIcon: 'pi pi-exclamation-triangle',
            rejectLabel: 'Отмена',
            rejectIcon: 'pi pi-ban',
            accept: () => {
              this.$nextTick(() => {
                this.confirmResend(value, subjectType);
              });
            }
          });
          return;
        } else if (this.isApplicationUuid(firstStringValue)) {
          subjectType = 'applicationUuid';
          this.confirmResend(value, subjectType);
          return;
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Ошибка ввода',
            detail: 'Неверный формат строкового идентификатора',
            life: 5000
          });
          return;
        }
      }

      this.confirmResend(value, subjectType);
    },
    confirmResend(value, subjectType) {
      this.$confirm.require({
        message: this.getConfirmMessage(value),
        header: 'Подтвердите перевыгрузку КИ',
        acceptLabel: 'Подтвердить',
        acceptIcon: 'pi pi-pencil',
        rejectLabel: 'Отмена',
        rejectIcon: 'pi pi-ban',
        accept: () => {
          this.setLoading(true);

          checkSendStops(value, subjectType, this.$confirm, this.$toast).then((subjects) => {
            if (subjects === null) {
              return;
            }

            return this.sendResend(subjects, subjectType);
          })
              .catch((err) => {
                ResponseService.handleErrorResponseWithoutForm(err, this.$toast)
              })
              .finally(() => {
                this.setLoading(false);
              })
        }
      })
    },
    sendResend(subjects, subjectType) {
      const formattedDate = this.fromDate ? this.formatDateToMSK(this.fromDate) : null;
      const issueEventDate = this.isIssueEventSelected && this.issueEventDate
          ? this.formatDateToMSK(this.issueEventDate)
          : null;
      const isOnlyRejected = this.isResend ? this.isOnlyRejected : false

      return LoanService.resendLoans(subjects, this.selectedBureaus, this.isResend, isOnlyRejected, formattedDate, subjectType, this.eventTypes, issueEventDate).then((res) => {
        if (res.failed === null || res.failed === undefined) {
          this.$toast.add({
            severity: 'success',
            summary: 'Перевыгрузка успешно начата',
            detail: res.feedback,
            life: 3000
          })
          this.$refs.form.clear()
          return;
        }

        this.$toast.add({
          severity: 'warn',
          summary: 'Ошибка создания отчетов на перевыгрузку по займам:',
          detail: res.failed ? res.failed.join(',') : subjects.join(','),
          life: 15000
        })
      })
    },
    getConfirmMessage(loans) {
      return `Перевыгрузить КИ для ${loans.length} займов?`;
    },
    setLoading(value) {
      this.loading = value
    },
    clear() {
      this.$refs.form.clear();
      this.fromDate = null;
      this.issueEventDate = null;
    },
    formatDateToMSK(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}T00:00:00+03:00`;
    }
  }
}
</script>
